/**
 * 返回承包商状态
 * @author wanghongling
 * @param val
 * @returns {*}
 */
function filterState (val) {
  let final
  switch (val) {
    case '0':
      final = '正常'
      break
    case '1':
      final = '异常'
      break
    default:
      final = ''
      break
  }
  return final
}
/**
 * 返回承包商经营许可证状态
 * @author wanghongling
 * @param val
 * @returns {*}
 */
function filterSXkztate (val) {
  let final
  switch (val) {
    case '0':
      final = '已到期'
      break
    case '1':
      final = '即将到期'
      break
    case '2':
      final = '正常'
      break
    default:
      final = '正常'
      break
  }
  return final
}
/**
 * 返回文字超过7个字显示省略号
 * @author wanghongling
 * @param val
 * @returns {*}
 */
function filterName (val) {
  let final
  if (val && val.length > 7) {
    final = val.substr(0, 7) + '...'
  } else {
    final = val
  }
  return final
}
/**
 * @Description:timeFilter时间过滤取值
 * @author wanghongling
 * @createDate 2020/2/28
*/
function timeFilter (val) {
  return val.substr(5, 8) + ':' + val.substr(-2)
}
/**
 * @Description:DateFilter日期过滤取值
 * @author wanghongling
 * @createDate 2020/2/28
*/
function DateFilter (val) {
  return val.substr(0, val.length - 3) + ':' + val.substr(-2)
}
/**
 * 过滤食堂名字返回第几食堂
 * @author wanghongling
 * @param val
 * @returns {*}
 */
function nameFilter (val) {
  var index = val.indexOf('第')
  val = val.substring(index, val.length)
  return val
}
/**
 * 过滤食堂异常个数，999返回999+
 * @author wanghongling
 * @param val
 * @returns {*}
 */
function shuLiangFilter (val) {
  return val > 999 ? '999+' : val
}
/**
 * @Description:添加分割符
 * @author wanghongling
 * @createDate 2020/3/2
 */
function filterSeparator(val) {
  if (val) {
    return val.join('、')
  } else {
    return '暂无'
  }
}
/**
 * @Description:添加分割符
 * @author wanghongling
 * @createDate 2020/3/2
 */
function filterYcName(val) {
  let final
  switch (val) {
    case '01':
      final = '证件异常'
      break
    case '02':
      final = '设备异常'
      break
    case '03':
      final = '人员异常'
      break
    case '04':
      final = '食品异常'
      break
    default:
      final = ''
      break
  }
  return final
}
/**
 * @Description:体温设备状态
 * @author wanghongling
 * @createDate 2020/4/28
*/
function filterDevState(val) {
  let final
  switch (val) {
    case '0':
      final = '离线'
      break
    case '1':
      final = '在线'
      break
    default:
      final = ''
      break
  }
  return final
}/**
 * 返回体温人员状态
 * @author wanghongling
 * @param val
 * @returns {*}
 */
function filterTemState (val) {
  let final
  switch (val) {
    case 0:
      final = '异常'
      break
    case 1:
      final = '正常'
      break
    case 2:
      final = '无体温'
      break
    default:
      final = ''
      break
  }
  return final
}

export {
  filterState,
  filterName,
  timeFilter,
  DateFilter,
  filterSXkztate,
  nameFilter,
  shuLiangFilter,
  filterSeparator,
  filterYcName,
  filterDevState,
  filterTemState
}



// WEBPACK FOOTER //
// ./src/filters.js